import { loadAppForDetail } from '@/api/apps'
import { listAllVersions, listVersions } from '@/api/versions'
import { confirmDisplayName } from '@/lib/appDisplayName'
import { useAppStore } from '@/store'

/**
 * 整表刷新应用详情 + 版本列表（始终 replace）。
 * 用于会改变线上版本的操作：确认弹窗等此 Promise，不在本地推断其它行状态。
 * 详情降级或分页不全时先翻页拉全量，再 replace，避免残留双 released。
 */
export async function refreshAppVersions(app_id: string): Promise<void> {
  let detail = await loadAppForDetail(app_id)
  let max_online_version: string | undefined

  if (!detail.versionsComplete) {
    const all = await listAllVersions(app_id)
    detail = {
      ...detail,
      versions: all.list,
      versionsComplete: true,
    }
    max_online_version = all.max_online_version
  } else {
    // max_online_version 只在版本列表接口；详情没有则另拉一页浅列表
    try {
      const page = await listVersions(app_id, { page: 1, page_size: 1 })
      max_online_version = page.max_online_version
    } catch {
      // 下限兜底仍可用 maxEverReleasedVersion
    }
  }

  const store = useAppStore.getState()
  store.upsertApp(detail.app)
  confirmDisplayName(detail.app.app_id || detail.app.id, detail.app.name)
  store.syncVersions(app_id, detail.versions, { replace: true })
  if (max_online_version !== undefined) {
    store.setMaxOnlineVersion(app_id, max_online_version)
  }
  store.bumpVersionsListRev()
}
